// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__VpSS-","info":"Note_info__2eunF","note":"Note_note__2l_uI","actions":"Note_actions__2iQwT"};